import React, { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import './ImageUpload.css'
import "cropperjs/dist/cropper.css";
import config from '../../config.json';
import UploadModal from "./ModalUpload";

const ImageUpload = ({squar, editModeImageSrc, setFinalImage, resetPreview}) => {

    let targetWidth = squar ? 400 : 1000;
    let targetHeight = squar ? 400 : 600;
    const [imageSrc, setImageSrc] = useState('');
    const [fileReader] = useState(new FileReader());
    const fileInput = useRef(null);
    const cropper = useRef(null);
    const [name, setName] = useState();
    const [type, setType] = useState();
    const [croppedImgSrc, setCroppedImgSrc] = useState();

    const [showModal, setShowMoadl] = useState(false);

    const handleFileRead = (event) => {
        setShowMoadl(true);
    }

    const handleChange = (event) => {
        const file = fileInput.current.files[0];
        const { name, type } = file;
        const imageSrc = URL.createObjectURL(event.target.files[0]);
        setName(name);
        setType(type);
        setImageSrc(imageSrc);
        setCroppedImgSrc(null);

        fileReader.onloadend = handleFileRead;
        fileReader.readAsBinaryString(file);
    }

    const cropHandler = () => {
        setShowMoadl(false);
        const croppedImgData = cropper.current.cropper
            .getCroppedCanvas()
            .toDataURL();

        setCroppedImgSrc(croppedImgData);
        const canvas = cropper.current.cropper.getCroppedCanvas();
        if (canvas.width <= targetWidth || canvas.height <= targetHeight) {
            targetWidth = canvas.width;
            targetHeight = canvas.height;
            const croppedImage = new Image();
            croppedImage.src = canvas.toDataURL();
            croppedImage.onload = () => {
                resizeFinalImage(croppedImage);
            }
        }
        else {
            const croppedImage = new Image();
            croppedImage.src = canvas.toDataURL();
            croppedImage.onload = () => {
                resizeFinalImage(croppedImage);
            }
        }
    }

    const resizeFinalImage = (orgImage) => {

        const scaleX = orgImage.naturalWidth / orgImage.width;
        const scaleY = orgImage.naturalHeight / orgImage.height;
        let canvas = document.createElement('canvas');

        canvas.width = targetWidth;
        canvas.height = targetHeight;
        let ctx = canvas.getContext('2d');

        ctx.drawImage(
            orgImage,
            0,
            0,
            orgImage.width * scaleX,
            orgImage.height * scaleY,
            0,
            0,
            targetWidth,
            targetHeight
        );
        const reader = new FileReader()
        canvas.toBlob(blob => {
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                setFinalImage(dataURLtoFile(reader.result, name))
            };
        }, type, 1)
    }

    const handleRotate = () => {
        cropper.current.cropper.rotate(90);
    }

    const dataURLtoFile = (dataurl, filename) => {
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        let croppedImage = new File([u8arr], filename, { type: mime });
        return croppedImage;
    }

    useEffect(() => {
        if(!resetPreview)
        return;
        setCroppedImgSrc();
      },[resetPreview])



    return (
        <div className="ImageUpload">
            <button type="button" onClick={() => fileInput.current.click()}
                className="btn btn-primary"
                style={{width: '131px'}}
            >
                <i className="fa fa-paperclip"></i>
                انتخاب عکس
            </button>
            <div className={`image-upload__preview ${squar && "image-upload__preview2"}`}>
                {croppedImgSrc && <img src={croppedImgSrc} alt="Preview" />}
                {!croppedImgSrc && editModeImageSrc && <img src={`${config.api_server}/${editModeImageSrc}`} alt=""/>}
                {!croppedImgSrc && !editModeImageSrc && <p> عکس انتخاب کن</p>} 
            </div>
            <input
                style={{ display: 'none' }}
                type="file"
                accept=".jpg,.png,.jpeg"
                ref={fileInput}
                onClick={(e) => e.target.value = null}
                onChange={handleChange}
            />
            <div>
                <UploadModal
                    show={showModal}
                    onCancel={() => setShowMoadl(false)}
                >
                    <div className="container-modal-content">
                        <div className="special">
                            <Cropper
                                style={{ width: 'auto', height: 'auto', maxWidth: "100%", maxHeight: "100%" }}
                                ref={cropper}
                                src={imageSrc}
                                aspectRatio={squar ? 1 : (5/3)}
                            />
                        </div>
                        <div className="btns-section">
                            <button className="btn-confirm"
                                onClick={cropHandler}
                            >
                                <i className="fa fa-check"></i>
                            </button>
                            <button className="btn-rotate" onClick={handleRotate}>
                                <i className="fa fa-refresh"></i>
                            </button>
                            <button className="btn-cancel" onClick={() => setShowMoadl(false)}>
                                <i className="fa fa-close"></i>
                            </button>
                        </div>
                    </div>
                </UploadModal>
            </div>
        </div>
    );
}

export default ImageUpload;